import { render, staticRenderFns } from "./AudienceDashboard.vue?vue&type=template&id=d976d092&"
import script from "./AudienceDashboard.vue?vue&type=script&lang=js&"
export * from "./AudienceDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports